import Axios from "axios";
import { takeLatest, put, call } from 'redux-saga/effects';
import { AUTH_SERVER } from '../../config';
import {
    FORGOT_PASSWORD,
    forgotPasswordSuccess,
    forgotPasswordFailure
} from './action';

export function* userForgotPassword(action) {
    let requestURL = `${AUTH_SERVER}/user/password/reset`;
    try {
        const result = yield call(Axios.post, requestURL, action.data);
        yield put(forgotPasswordSuccess(result.data));
    } catch (err) {
        yield put(forgotPasswordFailure(err))
    }
}
export function* forgotPassword() {
    yield takeLatest(FORGOT_PASSWORD, userForgotPassword);
}